import React, { useEffect, useState } from "react";
import {ILogEntry} from "../../models/LogEntry";
import { graphQLServices } from "../../../../services/GraphQLServices";
import {GET_JOB_STEP_RUN_LOGS} from "../graphql/queries/gqlGetJobStepRunLogs";
import {LogEntryModal} from "./LogEntries";

interface IJobStepRunLogProps {
	jobRunId: number;
	jobStepRunId: number;
}

export const JobStepRunLog: React.FC<IJobStepRunLogProps> = (props) => {
	const [data, setData] = useState<ILogEntry[]>([]);

	const fetch = () => {
		graphQLServices.querytoolClient.query({
			query: GET_JOB_STEP_RUN_LOGS,
			variables: {
				jobRunId: props.jobRunId,
				jobRunStepId: props.jobStepRunId,
			},
		})
			.then(result => setData(result?.data?.jobStepRuns?.nodes[0].logEntries ?? []));
	};

	useEffect(() => {
		fetch();
		// eslint-disable-next-line
	}, []);

	return <LogEntryModal logEntries={data} />;
};
